<template>
  <div>
    <div class="lestView">
      <img src="../assets/img/xcx.png" style="width: 100%" />
    </div>

    <div class="testlow-view">
      <div class="b-view"></div>
      <div>说明:</div>
    </div>

    <div class="contTextView">
      <div space="ensp">
        移花接木是为减少重复修谱工作，提高修谱效率。家族成员分别自己去统计自己的小家族，统计完成合并到一个大家族里面，该功能可与【智家谱】微信小程序结合使用。
      </div>
      <div space="ensp">
        移花：将您当前选择的成员以及该成员以下的分支进行复制。
      </div>
      <div space="ensp">接木：将您复制的信息粘贴到您当前选择的成员分支下。</div>
    </div>

    <div v-if="request_typ == 0" class="missing-XD" @click="didsavXD()">
      修订
    </div>
    <div class="buttBackView" v-if="request_typ == 1">
      <div class="liJInButt" @click="didYiHuaButt()">移花</div>
      <div class="liJInButt" @click="didJieMuButt()">接木</div>
    </div>
   
    <!-- 移花 -->
    <div
      class="commodity_screen"
      v-if="isYH"
       @click="didshareNoShow()"
      hover-stop-propagation="true"
    >
      <div class="topL"></div>
      <div class="chellView_contMian">
        <div class="chellView_cont">
          <div class="chellViewCont">
            <div class="chellView_image1">
              <img
                v-if="userDic.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="userDic.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_textcont">{{ userDic.username }}</div>
          </div>

          <div class="chellViewCont" v-if="userDic.wife">
            <div class="chellView_image1">
              <img
                v-if="userDic.wife.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="userDic.wife.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_textcont">{{ userDic.wife.username }}</div>
          </div>
        </div>
      </div>

      <div class="cherMianView">
        <div class="chellView_bottom">
          <block v-for="(item, index) in userDic.children" :key="index">
            <div class="chellView">
              <div class="chellView_image">
                <img
                  v-if="item.gender == 1"
                  src="../assets/img/icon_default_woman.png"
                  style="width: 100%; height: 100%"
                />
                <img
                  v-if="item.gender != 1"
                  src="../assets/img/icon_default_man.png"
                  style="width: 100%; height: 100%"
                />
              </div>
              <div class="chellView_text">{{ item.username }}</div>
            </div>
          </block>
        </div>

        <div class="queren" @click="didQueRenYiHua()">确认</div>
      </div>
    </div>

    <!-- 解析 -->
    <div v-if="isJX" class="commodity_screenJM"   hover-stop-propagation="true">
      <div class="textarName">请将移花得到的数据粘贴到文本框内</div>
      <textarea
        class="textareaView"
        οnpaste="return true;"
        v-model="testData"
      ></textarea>

      <div class="querentext" @click="didJieXiData()">开始解析</div>
    </div>

    <!-- 接木-->
    <div
      class="commodity_screenJM"
      v-if="isJM"
      hover-stop-propagation="true"
    >
      <div class="chellView_contMian">
        <div class="chellView_cont">
          <div class="chellViewCont">
            <div class="chellView_image1" v-if="userDic.thumb">
              <img :src="userDic.thumb" style="width: 100%; height: 100%" />
            </div>
            <div class="chellView_image1" v-if="!userDic.thumb">
              <img
                v-if="userDic.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="userDic.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_textcont">{{ userDic.username }}</div>
          </div>

          <div class="chellViewCont" v-if="userDic.wife">
            <div class="chellView_image1" v-if="userDic.wife.thumb">
              <img
                :src="userDic.wife.thumb"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_image1" v-if="!userDic.wife.thumb">
              <img
                v-if="userDic.wife.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="userDic.wife.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_textcont">{{ userDic.wife.username }}</div>
          </div>
        </div>
      </div>

      <div class="chellView_bottomJM">
        <div class="jmBT"></div>
      </div>
      <div v-if="charDic.wife">
        <div v-if="isBR == '1'" class="jmHl"></div>
        <div v-if="isBR == '2'" class="jmHr"></div>

        <div class="chellView_bottomJM">
          <div class="chellView_bottomJMcont">
            <div v-if="isBR == '1'" class="jmBl"></div>
          </div>
          <div class="chellView_bottomJMcont">
            <div v-if="isBR == '2'" class="jmBl"></div>
          </div>
        </div>
      </div>

      <div class="chellView_bottomJM" v-if="!charDic.wife">
        <div class="jmBl"></div>
      </div>

      <div class="chellView_bottomJM">
        <div class="chellView_bottomJMcont" @click="didBenrenButt()">
          <div class="chellViewContJM">
            <div class="chellView_image1" v-if="charDic.thumb">
              <img :src="charDic.thumb" style="width: 100%; height: 100%" />
            </div>
            <div class="chellView_image1" v-if="!charDic.thumb">
              <img
                v-if="charDic.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="charDic.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_textcont">{{ charDic.username }}</div>
            <div class="chellView_zxView">
              <img
                class="chellView_xz"
                v-if="isBR == '1'"
                src="../assets/img/xuanzhong_n.svg"
              />
              <img
                class="chellView_xz"
                v-if="isBR == '2'"
                src="../assets/img/xuanzhong_y.svg"
              />
            </div>
          </div>
        </div>
        <div
          class="chellView_bottomJMcont"
          v-if="charDic.wife"
          @click="didPeiouButt()"
        >
          <div class="chellViewContJM">
            <div class="chellView_image1" v-if="charDic.wife.thumb">
              <img
                :src="charDic.wife.thumb"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_image1" v-if="!charDic.wife.thumb">
              <img
                v-if="charDic.wife.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="charDic.wife.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_textcont">{{ charDic.wife.username }}</div>
            <div class="chellView_zxView">
              <img
                class="chellView_xz"
                v-if="isBR == '1'"
                src="../assets/img/xuanzhong_y.svg"
              />
              <img
                class="chellView_xz"
                v-if="isBR == '2'"
                src="../assets/img/xuanzhong_n.svg"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="cherMianView">
        <div class="chellView_bottom" v-if="charDic.children">
          <block v-for="(item, index) in charDic.children" :key="index">
            <div class="chellView">
              <div class="chellView_image" v-if="item.thumb">
                <img :src="item.thumb" style="width: 100%; height: 100%" />
              </div>
              <div class="chellView_image" v-if="!item.thumb">
                <img
                  v-if="item.gender == 1"
                  src="../assets/img/icon_default_woman.png"
                  style="width: 100%; height: 100%"
                />
                <img
                  v-if="item.gender != 1"

                  src="../assets/img/icon_default_man.png"
                  style="width: 100%; height: 100%"
                />
              </div>
              <div class="chellView_text">{{ item.username }}</div>
            </div>
          </block>
        </div>

        <div class="querenJM" @click="didQueRenJieMu()">确认</div>
      </div>
    </div>

    <tank v-if="password_show" @childFn="parentFn"></tank>
  </div>
</template>

<script>
import Tank from "./TanK.vue";
export default {
  components: { Tank },

  data() {
    return {
      isJX: false,
      isYH: false,
      isJM: false,
      isBR: "1",
      homeId: "",
      userDic: null,
      userjson: "",
      charDic: null,

      testData: null,

      dataSource: null,
      request_typ: 0,
      password_show: false,
    };
  },
  methods: {
    didshareNoShow: function () {
       this.isYH = false;
    },
    //修订查询
    didsavXD: function () {
      this.password_show = true;
    },

    //监听弹框点击事件
    parentFn(payload) {
      this.password_show = false;
      if (payload == "OK") {
        this.request_typ = 1;
      }
    },

    //点击移花按钮
    didYiHuaButt: function () {
      this.isYH = true;
    },
    //点击确认移花
    didQueRenYiHua: function () {
      var userjson = this.userjson;

      var reg = /"http(.*?)"/g;
      var items = userjson.match(reg);
      if (items && items.length > 0) {
        for (var i = 0; i < items.length; i++) {
          let itemStr = items[i];
          userjson = userjson.replace(itemStr, "null");
        }
      }

      var aesjson = this.encrypt(userjson);
      var tag = document.createElement("input");
      tag.setAttribute("id", "cp_zdy_input");
      tag.value = aesjson;
      document.getElementsByTagName("body")[0].appendChild(tag);
      document.getElementById("cp_zdy_input").select();
      document.execCommand("copy");
      document.getElementById("cp_zdy_input").remove();

      this.isYH = false;
    },

    //点击接木
    didJieMuButt: function () {
      this.isJX = true;
    },

    //开始解析
    didJieXiData: function () {
      console.log("开始解析");

      if (this.testData) {
        var aesEncryStr = this.decrypt(this.testData);
        aesEncryStr = aesEncryStr.replace(
          /cloud:\/\/zhangminglingzs.7a68-zhangminglingzs-1252972788/g,
          "https://7a68-zhangminglingzs-1252972788.tcb.qcloud.la"
        );
        var charDic = JSON.parse(aesEncryStr);
        this.charDic = charDic;
        this.isJX = false;
        this.isJM = true;
      }
    },
    //点击本人接木
    didBenrenButt: function () {
      this.isBR = "1";
    },

    //点击配偶接木
    didPeiouButt: function () {
      this.isBR = "2";
    },

    //点击确认接木
    didQueRenJieMu: function () {
      this.isJM = false;
      var charDicMian = null;
      var userDic = this.userDic;
      var charDic = this.charDic;
      var isBR = this.isBR;
      if (userDic.username == charDic.username) {
        alert("家谱中已存在该成员");
        return;
      }

      if (isBR == "1") {
        charDic.ranking = "";
        charDicMian = charDic;
      } else {
        var wifeDic = charDic.wife;
        var children = charDic.children;
        var userDicwife = {
          address: charDic.address,
          anSign: charDic.anSign,
          birthday: charDic.birthday,
          gender: charDic.gender,
          isBind: charDic.isBind,
          is_wife: "1",
          nameid: charDic.nameid,
          nickname: charDic.nickname,
          ranking: charDic.ranking,
          telPhone: charDic.telPhone,
          thumb: charDic.thumb,
          username: charDic.username,
        };

        charDicMian = wifeDic;
        charDicMian.is_wife = "0";
        charDicMian.children = children;
        charDicMian.wife = userDicwife;
      }
      this.readData(charDicMian);
    },
    ///读取数据
    readData: function (charDicMian) {
      var that = this;
      let password = localStorage.getItem("passwodr");
      var prem = {
        pass_wode: password,
      };
      this.axios
        .post(this.COMMON.httpUrl + "go_home/readata", prem)
        .then((res) => {
          if (res.data.code == 1) {
            var familyJson = res.data.data.familyJson;
            if (familyJson) {
              var familyJsonStr = this.COMMON.decode(familyJson);
              that.addminChildren(familyJsonStr, charDicMian);
            }
          } else if (res.data.code == 2) {
            that.$router.push({ name: "homeBook" });
          }
        });
    },
    //添加接木
    addminChildren: function (jsonData, childrendic) {
      var chrenameid = childrendic.nameid;
      if (jsonData.indexOf(chrenameid) != -1) {
        alert("家谱中已存在该成员");
        return;
      }

      if (childrendic.wife) {
        var chrenameWerid = childrendic.wife.nameid;
        if (jsonData.indexOf(chrenameWerid) != -1) {
          alert("家谱中已存在该成员");
          return;
        }
      }

      var dicData = JSON.parse(jsonData);
      var nameid = this.userDic.nameid;
      var treeData = dicData;

      each(treeData);
      function each(data) {
        if (data.nameid == nameid) {
          addchildren(data);
          return;
        } else if (data.wife && data.wife.nameid == nameid) {
          addchildren(data);
          return;
        } else if (data.children && data.children.length > 0) {
          for (var i = 0; i < data.children.length; i++) {
            var dic = data.children[i];
            if (dic.nameid == nameid) {
              addchildren(dic);
              return;
            } else if (dic.wife && dic.wife.nameid == nameid) {
              addchildren(dic);
              return;
            } else if (dic.children && dic.children.length > 0) {
              each(dic, nameid);
            }
          }
        }
      }

      function addchildren(data) {
        if (data.children) {
          data.children.push(childrendic);
        } else {
          var newchildren = new Array();
          newchildren.push(childrendic);
          data.children = newchildren;
        }
      }

      this.addUpdata(treeData);
    },
    //保存信息
    addUpdata: function (childrendic) {
      let that = this;
      var familyJson = JSON.stringify(childrendic);
      var familyJsonBase = this.COMMON.encode(familyJson);
      let password = localStorage.getItem("passwodr");
      let tokencode = localStorage.getItem("passwodrEit");
      var prem = {
        pass_wode: password,
        token_code: tokencode,
        family_json: familyJsonBase,
      };
      this.axios
        .post(this.COMMON.httpUrl + "go_home/addupdata", prem)
        .then((res) => {
          if (res.data.code == 1) {
            that.$router.go(-1);
          } else if (res.data.code == 2) {
            alert("密码错误,请重新登录");
          }
        });
    },
  },
  mounted: function () {
    var options = this.$route.params;
    var userjson = options.dicjson;
    if (userjson) {
      userjson = userjson.replace(/hymen/g, "hy");
      var userDic = JSON.parse(userjson);
      this.homeid = options.homeid;
      this.userDic = userDic;
      this.userjson = userjson;
    }

    var passwodrEit = localStorage.getItem("passwodrEit");
    if (passwodrEit && passwodrEit != 0) {
      this.request_typ = 1;
    }
  },
};
</script>

<style scoped>
/* 按钮 */
.lestView {
  margin-left: 25%;
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.buttBackView {
  margin-top: 40px;
  width: 94%;
  margin-left: 3%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.liJInButt {
  width: 165px;
  height: 45px;
  background-color: #0c3874;
  color: white;
  font-size: 17px;
  text-align: center;
  line-height: 45px;
  border-radius: 5px;
}

/*  */
.testlow-view {
  margin-left: 3%;
  /* margin-top:60px; */
  width: 94%;
  height: 42px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 15px;
  color: #333;
}

.b-view {
  width: 2px;
  height: 15px;
  background-color: #0c3874;
  margin-right: 5px;
}

.contTextView {
  width: 94%;
  margin-left: 3%;
  color: #444444;
  font-size: 13px;
  line-height: 30px;
}

/* 移花 */
.commodity_screen {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(1, 1, 1, 0.8);
  overflow: hidden;
  z-index: 9999;
  padding-top: 100px;
}
.topL {
  width: 2px;
  height: 40px;
  margin-left: 50%;
  border-right: 1.5px dashed #f3f3f3;
}
.chellView_contMian {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.chellView_cont {
  padding-top: 10px;
  padding-bottom: 5px;
  padding-right: 5px;
  padding-left: 5px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 3px;
}
.chellView_image1 {
  margin: 0 auto;
  width: 75px;
  height: 75px;
}
.chellViewCont {
  width: 75px;
}

.chellView_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 3px;
  flex-wrap: wrap;
}

.chellView {
  margin-top: 3px;
  margin-bottom: 5px;
  width: 60px;
  height: 75px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: #fff;
  border-radius: 3px;
}
.chellView_image {
  margin: 0 auto;
  margin-top: 5px;
  width: 45px;
  height: 45px;
}
.chellView_text {
  width: 100%;
  text-align: center;
  line-height: 25px;
  font-size: 10px;
}
.chellView_textcont {
  width: 100%;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
}

.scrollview {
  width: 99%;
  margin-left: 0.5%;
  height: 75px;
}
.scrollview-boom {
  display: flex;
  flex-direction: row;
}

.queren {
  width: 90%;
  margin-left: 5%;
  height: 50px;
  margin-top: 50px;
  background-color: red;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
}
.cherMianView {
  width: 100%;
  height: 90px;
}

/* 接木 */
.commodity_screenJM {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(1, 1, 1, 0.8);
  overflow: hidden;
  z-index: 9999;
  padding-top: 25px;
}
.chellView_bottomJM {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.chellView_bottomJMcont {
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.chellViewContJM {
  width: 80px;
  padding: 5px;
  background-color: white;
}
.chellView_zxView {
  width: 100%;
  text-align: center;
}
.chellView_xz {
  width: 20px;
  height: 20px;
  margin: 0 auto;
}

.jmTop {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.jmBT {
  width: 1px;
  height: 30px;
  background-color: #f3f3f3;
}
.jmHl {
  width: 25%;
  margin-left: 25%;
  height: 1px;
  background-color: #f3f3f3;
}
.jmHr {
  width: 25%;
  margin-left: 50%;
  height: 1px;
  background-color: #f3f3f3;
  padding-right: 1px;
}
.jmBl {
  width: 1px;
  height: 20px;
  background-color: #f3f3f3;
}

.querenJM {
  width: 96%;
  margin-left: 2%;
  height: 50px;
  margin-top: 15px;
  background-color: red;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
}
.missing-XD {
  width: 94%;
  margin-left: 3%;
  margin-top: 20px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: burlywood;
  color: #fff;
  border-radius: 3px;
}

/* 复制框 */
.textarName {
  widows: 100%;
  text-align: center;
  margin-top: 100px;
  height: 50px;
  color: white;
}
.textareaView {
  margin-left: 10%;
  width: 80%;
  height: 200px;
  background-color: #f3f3f3;
}
.querentext {
  width: 90%;
  margin-left: 5%;
  height: 50px;
  margin-top: 50px;
  background-color: green;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
}
</style>